import React from 'react';

function Tile(props) {
  const origClasses = props.className ? props.className : "";
  const scndKey = props.scndKey ? " mdc-calc-tile__secondary" : "";
  let size = "";
  if(props.size) {
    if(props.size === "small")  size = " mdc-calc-tile__small-text";
    if(props.size === "medium") size = " mdc-calc-tile__medium-text";
    if(props.size === "large") size = " mdc-calc-tile__large-text";
  } else {
    size = " mdc-calc-tile__large-text"
  }

  let theme = "";
  if(props.theme) {
    theme = " mdc-calc-tile__theme";
  }

  let classes = "mdc-calc-tile" + scndKey + size + theme;
  if(origClasses.length > 0) classes += " " + origClasses;
  return (
      <div onClick={props.onClick} className={classes}>
        {props.children}
      </div>
  );
}

export default Tile;



// WEBPACK FOOTER //
// ./src/MDCCalc/Tile.js